<div class="container-fluid py-4">
  <div class="row mb-4 justify-content-center">
    <ng-container *ngFor="let card of resumenCards; index as i">
      <div class="col-3 col-md-2">
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 2 }"
          [routerLink]="card.route"
          [style.cursor]="card.route || i === 2 ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow icon-card"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>

              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 2, 'text-white': i !== 2 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>

          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 2 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>

      <!-- SALTO DE FILA después de la 4ta tarjeta (i = 3) -->
      <div *ngIf="i === 3" class="w-100"></div>
    </ng-container>
  </div>
  <div class="row mb-6 mt-4">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a class="btn btn-dark btn-sm btn-new" [routerLink]="['/observability/social']">Social Main</a>
        <a class="btn btn-dark btn-sm btn-reg ms-2" [routerLink]="['/observability/social/audits']">Audits & Incidents</a>
        <a class="btn btn-dark btn-sm btn-new ms-2" [routerLink]="['/observability/social/executive']">Executive View</a>
        <a class="btn btn-dark btn-sm btn-new ms-2" [routerLink]="['/observability/social/leads']">Leads & Community</a>
      </div>
    </div>
  </div>

  <!--  Section Tabs  -->
  <div class="section-tabs mt-3">
    <button
      class="btn-tab"
      [class.active]="activeSection === 'overview'"
      (click)="setSection('overview')"
    >
      <i class="fas fa-chart-pie me-1"></i> Dashboard Overview
    </button>
    <button
      class="btn-tab"
      [class.active]="activeSection === 'incidents'"
      (click)="setSection('incidents')"
    >
      <i class="fas fa-exclamation-circle me-1"></i> Incidents Log
    </button>
    <button
      class="btn-tab"
      [class.active]="activeSection === 'root-cause'"
      (click)="setSection('root-cause')"
    >
      <i class="fas fa-search me-1"></i> Root Causes
    </button>
  </div>

  <!--  Search bar  -->
  <div class="row mb-3 mt-3">
    <div class="col-md-5">
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          placeholder="Search events, entities, reasons..."
          [(ngModel)]="searchText"
          (ngModelChange)="filterInfo()"
          autocomplete="off"
        />
        <span class="input-group-text bg-transparent">
          <i class="fas fa-search text-dark"></i>
        </span>
      </div>
    </div>
    <div class="col-md-3 d-flex align-items-center">
      <span *ngIf="loading" class="text-muted ms-2">
        <i class="fas fa-spinner fa-spin me-1"></i> Loading…
      </span>
    </div>
  </div>

  <!--  OVERVIEW SECTION  -->
  <ng-container *ngIf="activeSection === 'overview'">
    <h6 class="text-muted text-uppercase mb-3 fw-bold">
      <i class="fas fa-chart-pie me-2"></i>Audit Overview KPIs
    </h6>
    <div class="kpi-grid mb-4">
      <div class="kpi-card" style="border-left-color: #dc3545">
        <i
          class="fas fa-exclamation-triangle kpi-icon"
          style="color: #dc3545"
        ></i>
        <div class="kpi-value">{{ incidentsCreated }}</div>
        <div class="kpi-label">Incidentes</div>
      </div>

      <div class="kpi-card" style="border-left-color: #007bff">
        <i class="fas fa-shield-alt kpi-icon" style="color: #007bff"></i>
        <div class="kpi-value">{{ safeStatesActivated }}</div>
        <div class="kpi-label">Safe States Activados</div>
      </div>

      <div class="kpi-card" style="border-left-color: #28a745">
        <i class="fas fa-tools kpi-icon" style="color: #28a745"></i>
        <div class="kpi-value">{{ recoveryActions }}</div>
        <div class="kpi-label">Recovery Actions</div>
      </div>

      <div class="kpi-card" style="border-left-color: #fd7e14">
        <i class="fas fa-stopwatch kpi-icon" style="color: #fd7e14"></i>
        <div class="kpi-value">
          {{ avgDurationMinutes }} <small style="font-size: 0.8rem">min</small>
        </div>
        <div class="kpi-label">Avg Duration</div>
      </div>
    </div>
  </ng-container>

  <!--  INCIDENTS / AUDIT LOG SECTION  -->
  <ng-container
    *ngIf="activeSection === 'incidents' || activeSection === 'overview'"
  >
    <h6
      class="text-muted text-uppercase mb-3 fw-bold"
      [class.mt-4]="activeSection === 'overview'"
    >
      <i class="fas fa-list me-2"></i>Audit Event Log
    </h6>

    <div class="table-responsive bg-white rounded shadow-sm">
      <table class="obs-table">
        <thead>
          <tr>
            <th>Event Name</th>
            <th>Entity Type</th>
            <th>Entity ID</th>
            <th>Triggered By</th>
            <th>Reason Code</th>
            <th>Time / Duration</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="auditLog.length > 0; else noEvents">
            <tr *ngFor="let item of auditLog">
              <td>
                <i [class]="getEventIcon(item.event_name) + ' me-2'"></i>
                <span
                  class="badge rounded-pill bg-light text-dark fw-bold border"
                  >{{ item.event_name }}</span
                >
              </td>
              <td>{{ item.entity_type }}</td>
              <td class="text-muted small">{{ item.entity_id }}</td>
              <td>
                <span class="badge bg-secondary">{{
                  item.triggered_by_type
                }}</span>
              </td>
              <td [class.text-danger]="item.event_name.includes('incident')">
                {{ item.reason_code || "-" }}
              </td>
              <td>
                <div class="small fw-bold">
                  {{ item.createdAt | date: "short" }}
                </div>
                <div
                  class="small text-muted"
                  *ngIf="item.payload?.duration_minutes"
                >
                  <i class="fas fa-clock me-1"></i
                  >{{ item.payload.duration_minutes }} min
                </div>
              </td>
            </tr>
          </ng-container>
          <ng-template #noEvents>
            <tr>
              <td colspan="6" class="text-center text-muted py-4">
                No audit events match the filter criteria.
              </td>
            </tr>
          </ng-template>
        </tbody>
      </table>
    </div>
  </ng-container>

  <!--  ROOT CAUSES SECTION  -->
  <ng-container *ngIf="activeSection === 'root-cause'">
    <h6 class="text-muted text-uppercase mb-3 fw-bold">
      <i class="fas fa-search me-2"></i>Root Causes (Incidents & Safe States)
    </h6>

    <div class="row">
      <div class="col-md-6">
        <div class="table-responsive bg-white rounded shadow-sm p-2">
          <table class="obs-table">
            <thead>
              <tr>
                <th>Reason Code</th>
                <th>Incidentes / SS Activations</th>
                <th class="bar-cell">Share</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="topRootCauses.length > 0; else noCauses">
                <tr *ngFor="let rc of topRootCauses">
                  <td>
                    <span class="badge bg-dark fw-normal">{{ rc.reason }}</span>
                  </td>
                  <td>
                    <strong>{{ rc.count }}</strong>
                  </td>
                  <td class="bar-cell">
                    <div class="progress">
                      <div
                        class="progress-bar bg-danger"
                        [style.width.%]="
                          totalRootCausesCount() > 0
                            ? (rc.count / totalRootCausesCount()) * 100
                            : 0
                        "
                      ></div>
                    </div>
                  </td>
                </tr>
              </ng-container>
              <ng-template #noCauses>
                <tr>
                  <td colspan="3" class="text-center text-muted py-4">
                    No root causes data available for the filtered events.
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>

      <div class="col-md-6">
        <div class="kpi-grid">
          <div
            *ngFor="let rc of topRootCauses"
            class="kpi-card"
            style="border-left-color: #dc3545"
          >
            <i class="fas fa-bug kpi-icon text-danger"></i>
            <div class="kpi-value">{{ rc.count }}</div>
            <div class="kpi-label">{{ rc.reason }}</div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
